import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {LegalEntity} from 'src/app/domain/core/legal-entity.model';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {NavigationEnd, Router} from '@angular/router';
import {filter, Subscription} from 'rxjs';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-footer',
    imports: [
        FaIconComponent
    ],
    templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() legalEntity: LegalEntity = LegalEntity.ToyotaGermany;
  @Input() consentVersion: string;

  currentUrl = '';
  noFooter = false;

  private routerSub?: Subscription;
  protected readonly faChevronRight = faChevronRight;

  constructor(private router: Router) {}

  get year() {
    return new Date().getFullYear();
  }

  ngOnInit() {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl = event.urlAfterRedirects;
        this.checkNoFooter();
      });

    this.currentUrl = this.router.url;
    this.checkNoFooter();
  }

  private checkNoFooter() {
    const firstSegment = this.currentUrl.split('/').filter(Boolean)[0] ?? '';
    this.noFooter = firstSegment === 'digSig';
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }
}
